import { useTranslation } from "react-i18next";
import { Outlet, NavLink, useLocation, Link } from "react-router-dom";

export function TermsContainer() {
  const { t } = useTranslation();

  const location = useLocation();

  const isEnglish = location.pathname.startsWith("/terms/en");

  return (
    <div className="flex flex-col flex-grow min-h-0">
      <header className="sticky top-0 flex items-center h-16 p-4 bg-white shadow">
        <div>
          <NavLink to="/auth/signin">
            <img
              src="/assets/images/track_logo.svg"
              alt="logo"
              className="h-8"
            />
          </NavLink>
        </div>
      </header>
      <main className="flex flex-col flex-grow py-16 px-4 gap-10 overflow-auto min-h-0">
        <h1 className="text-2xl font-bold text-center">
          {t("terms.title", { lng: isEnglish ? "en" : "ja" })}
        </h1>
        <div className="flex justify-between max-w-3xl mx-auto w-full gap-4 p-4 rounded bg-blue-100">
          <div className="flex gap-2">
            <div className="font-bold text-blue-900">
              {isEnglish ? "JA" : "EN"}
            </div>
            <div>{t("terms.lang.title", { lng: isEnglish ? "ja" : "en" })}</div>
          </div>
          <Link
            to={isEnglish ? "/terms" : "/terms/en"}
            className="text-blue-900 underline"
          >
            {t("terms.lang.link", { lng: isEnglish ? "ja" : "en" })}
          </Link>
        </div>
        <div className="flex flex-col bg-white rounded-lg shadow p-8 max-w-3xl mx-auto w-full prose track-terms">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
